var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from "path-shared/models/filter-data";
var ErrorsMatriculaFilter = /** @class */ (function (_super) {
    __extends(ErrorsMatriculaFilter, _super);
    function ErrorsMatriculaFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.nomesNoves = null;
        _this.nomesVelles = null;
        _this.exp = '';
        _this.matricula = '';
        _this.labels['nomesNoves'] = _this.i18n('No mostrar matrículas con errores');
        _this.labels['nomesVelles'] = _this.i18n('Mostrar solo matrículas con errores');
        _this.labels['exp'] = _this.i18n('Expedient');
        _this.labels['matricula'] = _this.i18n('Matrícula');
        return _this;
    }
    return ErrorsMatriculaFilter;
}(FilterData));
export { ErrorsMatriculaFilter };
